<template>
	<div class="popup-overlay" v-show="handleShow" ref="popup">
		<div class="popup box-white" ref="inner">
			<div class="popup-inner">
				<span class="popup-close" @click="close()" v-if="hasClose"></span>
				<component :is="computedComponent"></component>
			</div>
		</div>
	</div>
</template>

<script>
import CalcRegistration from '@/components/popups/CalcRegistration';
import Registration from '@/components/popups/Registration';
import RegistrationSending from '@/components/popups/RegistrationSending';
import Login from '@/components/popups/Login';
import EmailVerify from '@/components/popups/EmailVerify';
import FloorAreaLists from '@/components/popups/FloorAreaLists';
import PropertyMovables from '@/components/popups/PropertyMovables';
import PropertyValuables from '@/components/popups/PropertyValuables';
import ForgottenPassword from '@/components/popups/ForgottenPassword';
import ForgottenPasswordSending from '@/components/popups/ForgottenPasswordSending';
import RealEstateChooser from '@/components/popups/RealEstateChooser';
import Consultant from '@/components/popups/Consultant';
import Valuable200k from '@/components/popups/Valuable200k';
import ContractingLogin from '@/components/popups/ContractingLogin';
import ContractingRegistration from '@/components/popups/ContractingRegistration';
import ContractingVerify from '@/components/popups/ContractingVerify';
import OutbuildingSamePlace from '@/components/popups/OutbuildingSamePlace';
import StartOfRiskChanger from '@/components/popups/StartOfRiskChanger';
import { lock, unlock } from 'tua-body-scroll-lock';
import { mapMutations } from 'vuex';
import ContractTypeChange from "@/components/popups/ContractTypeChange.vue";
import ConsultantRealEstateChooser from "@/components/popups/ConsultantRealEstateChooser.vue";
import BikaImportNewEmail from "@/components/popups/BikaImportNewEmail.vue";
import MatchingCalculation from "@/components/popups/MatchingCalculation.vue";
import SKTrendSendSuccess from "@/components/popups/SKTrendSendSuccess.vue";
import SKTrendSendFail from "@/components/popups/SKTrendSendFail.vue";
import TerminationOverdue from "@/components/popups/TerminationOverdue.vue";
export default {
	props: {
		thisComponent: { type: String, default: null },
		show: { type: Boolean, default: false },
		hasClose: { type: Boolean, default: true },
	},
	data() {
		return {
			component: null,
			resolver: null
		};
	},
	computed: {
		computedComponent() {
			return this.component !== null ? this.component : this.thisComponent;
		},
		handleShow() {
			if (this.$refs.popup !== undefined) {
				this.show ? lock(this.$refs.inner) : unlock(this.$refs.inner);
			}
			return this.show;
		},
	},
	components: {
		CalcRegistration,
		Registration,
		RegistrationSending,
		Login,
		EmailVerify,
		FloorAreaLists,
		PropertyMovables,
		PropertyValuables,
		ForgottenPassword,
		ForgottenPasswordSending,
		RealEstateChooser,
        ConsultantRealEstateChooser,
		Consultant,
		Valuable200k,
		ContractingLogin,
		ContractingRegistration,
		ContractingVerify,
		OutbuildingSamePlace,
		StartOfRiskChanger,
        ContractTypeChange,
        BikaImportNewEmail,
        MatchingCalculation,
        SKTrendSendSuccess,
        SKTrendSendFail,
        TerminationOverdue,
	},
	methods: {
		...mapMutations(['showPopup']),
		close() {
			if (this.hasClose) {
				unlock(this.$refs.popup[0]);
				this.$emit('close');
			}
		},
		asyncShow(popup) {
			return new Promise(resolve => {
				this.showPopup(popup);
				this.resolver = resolve;
			});
		},
		resolve(data) {
			this.resolver(data);
			this.close();
		}
	},
};
</script>
